import { useSearchParams } from "react-router-dom";

export const useIsExpired = () => {
  const [searchParams] = useSearchParams();
  const lbTypeStatus = searchParams.get("lbTypeStatus");
  return lbTypeStatus === "expired";
};
